import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './NavBar.css';

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="header">
      <nav className={`nav${isOpen ? ' open' : ''}`}>
        <Link 
          to="/" 
          className={`nav-link ${isActive('/')}`} 
          onClick={closeMenu}
        >
          Home
        </Link>
        <Link 
          to="/members" 
          className={`nav-link ${isActive('/members')}`} 
          onClick={closeMenu}
        >
          Members
        </Link>
        <Link 
          to="/apply" 
          className={`nav-link ${isActive('/apply')}`} 
          onClick={closeMenu}
        >
          Apply
        </Link>
        <Link 
          to="/events" 
          className={`nav-link ${isActive('/events')}`} 
          onClick={closeMenu}
        >
          Events
        </Link>
        <Link 
          to="/gallery" 
          className={`nav-link ${isActive('/gallery')}`} 
          onClick={closeMenu}
        >
          Gallery
        </Link>
        <Link 
          to="/bookings" 
          className={`nav-link ${isActive('/bookings')}`} 
          onClick={closeMenu}
        >
          Bookings
        </Link>
        <Link 
          to="/contact" 
          className={`nav-link ${isActive('/contact')}`} 
          onClick={closeMenu}
        >
          Contact
        </Link>
      </nav>
      <div className="mobile-header">
        <div className="logo">KYC</div>
        <button
          className={`menu-toggle${isOpen ? ' open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isOpen}
        >
          <span className="hamburger"></span>
          <span className="hamburger"></span>
          <span className="hamburger"></span>
        </button>
      </div>
      {isOpen && <div className="overlay" onClick={closeMenu}></div>}
    </header>
  );
};

export default NavBar;
